import React from "react"

const Loader: React.FC<{ className?: string }> = ({ className }) => {
    return (
        <div className={`${className} flex h-full items-center justify-center`}>
            <div className="h-120 w-120 animate-spin rounded-full border-4 border-gray-300 border-t-black"></div>
        </div>
    )
}

export default Loader
